import { adminHttpClient } from '../commons/adminHttpClient'

export type EligibleEmployeeOptedInStatusStatistic = {
  activeEligibleEmployees: number
  activeOptedInEligibleEmployees: number
  annuallyAttested: number
  premiumSubmitted: number
  premiumVerified: number
  premiumReimbursed: number
}

const getEligibleEmployeeOptedInStatusStatistic = (
  planPeriodId: string,
): Promise<EligibleEmployeeOptedInStatusStatistic> => {
  return adminHttpClient.get(`/Benefit/EligibleEmployeeOptedInStatusStatistic/${planPeriodId}`)
}

export default getEligibleEmployeeOptedInStatusStatistic
